const time = {
    ms: (seconds) => seconds * 1000,
    s: (milliseconds) => milliseconds / 1000,
};

export { time };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/utils/dist/time.es.js
// module id = 2uYW
// module chunks = 0